<input [formControl]="ngControl.control"
       pInputText
       id="{{inputId}}"
       type="number"
       min="0"
       (input)="onPercentageChange.emit(+$event.target.value)"
       max="100"/>
<span style="margin-left: 2px;">%</span>
<rb-error-marker [control]="ngControl.control"></rb-error-marker>
